module.exports = __webpack_public_path__ + "static/img/iconfont.73ebeef.svg";


//////////////////
// WEBPACK FOOTER
// ./static/iconfont/iconfont.svg?t=1664260425800
// module id = nUBI
// module chunks = 19